export const EASE_OUT_STRONG = [0.23, 1, 0.32, 1] as [
  number,
  number,
  number,
  number,
];

/**
 * easeInQuint — the mirror of {@link EASE_OUT_STRONG}.
 *
 * Holds a value at its start for most of the duration, then moves it almost all at once at
 * the end. The exit half of an asymmetric pair: an element the user has finished with
 * should linger rather than snatch the eye, then leave quickly once it does go.
 */
export const EASE_IN_STRONG = [0.7, 0, 0.84, 0] as [
  number,
  number,
  number,
  number,
];
